import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { Services } from './Services.js';
import { servicesProviderAssemblyDataSchema } from './ServicesProviderAssemblyData.js';
import { PayableServicesProvider } from './ServicesProviderPayable.js';

class ServicesProviderAssembly extends PayableServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
    }
    validateData(data) {
        const result = servicesProviderAssemblyDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderAssembly.validation', `ServicesProviderAssembly data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.ASSEMBLY,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.ASSEMBLY, ServicesProviderAssembly);

export { ServicesProviderAssembly };
//# sourceMappingURL=ServicesProviderAssembly.js.map
